import { render } from "./B2bTableIssues.vue?vue&type=template&id=5dffcb44&scoped=true&lang=pug"
import script from "./B2bTableIssues.vue?vue&type=script&lang=js"
export * from "./B2bTableIssues.vue?vue&type=script&lang=js"

import "./B2bTableIssues.vue?vue&type=style&index=0&id=5dffcb44&lang=scss&scoped=true"
import "./B2bTableIssues.vue?vue&type=style&index=1&id=5dffcb44&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dffcb44"]])

export default __exports__